import Marquee from "react-fast-marquee";

export default function KineticMarquee({
  items = [
    "Robotics",
    "Gen AI",
    "IoT",
    "App Dev",
    "3D Printing",
    "Mentorship",
    "Lab Setup",
    "STEM",
    "Maker",
    "Future-Ready",
  ],
  speed = 38,
  variant = "dark",
}) {
  const dark = variant === "dark";
  return (
    <div
      data-testid="kinetic-marquee"
      className={`border-y ${
        dark
          ? "bg-[var(--ri-ink)] text-white border-[var(--ri-ink)]"
          : "bg-[var(--ri-bg)] text-[var(--ri-ink)] border-[var(--ri-line)]"
      } py-5`}
    >
      <Marquee speed={speed} gradient={false} pauseOnHover>
        {items.concat(items).map((it, idx) => (
          <span
            key={idx}
            className="font-display text-3xl md:text-5xl mx-8 inline-flex items-center gap-8"
          >
            <span className={dark ? "text-[var(--ri-orange)]" : "text-[var(--ri-orange)]"}>✱</span>
            <span className="kinetic-marquee-item" style={dark ? { WebkitTextStroke: "1px #fff", color: "transparent" } : { WebkitTextStroke: "1px #0a0a0a", color: "transparent" }}>
              {it}
            </span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
